"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingURLEncoder = void 0;
const lodash_1 = require("lodash");
const dateCoder_1 = require("./dateCoder");
const schedulingFormulaParamCoder_1 = require("./schedulingFormulaParamCoder");
class BookingURLEncoder {
    static encode(urlParams) {
        const formulaParam = this.encodeFormula(urlParams.formula);
        const bufferParam = this.encodeBuffer(urlParams.buffer);
        const dateRange = this.encodeDateRange(urlParams.start, urlParams.end);
        const bookingCalendars = this.encodeCalendar(urlParams.bookingCalendarIds);
        const locations = this.encodelocation(urlParams.location);
        const booker = this.encodeBooker(urlParams.booker);
        const proxy = this.encodeProxy(urlParams.proxy);
        const room = this.encodeRoom(urlParams.room);
        const bookingId = this.encodeBookingId(urlParams.bookingId);
        const allowReschedule = this.encodeAllowReschedule(urlParams.allowReschedule);
        const allowCancel = this.encodeAllowCancel(urlParams.allowCancel);
        const params = this.joinParams(dateRange, formulaParam, bufferParam, bookingCalendars, locations, booker, proxy, room, bookingId, allowReschedule, allowCancel);
        return `/${urlParams.userId}/${urlParams.lengthMin}${params}`;
    }
    static encodeFormula(formula) {
        const encoded = schedulingFormulaParamCoder_1.SchedulingFormulaParamEncoder.encode(formula);
        if ((0, lodash_1.isEmpty)(encoded)) {
            return '';
        }
        return `formula=${encoded}`;
    }
    // フロントから使ってる
    static encodeDateRange(start, end) {
        if ((0, lodash_1.isUndefined)(start) || (0, lodash_1.isUndefined)(end))
            return '';
        return `start=${(0, dateCoder_1.formatFullDate)(start)}+end=${(0, dateCoder_1.formatFullDate)(end)}`;
    }
    static encodeBuffer(buffer) {
        if ((0, lodash_1.isUndefined)(buffer)) {
            return '';
        }
        return `buffer=${buffer}`;
    }
    static encodeCalendar(calendarIds) {
        if ((0, lodash_1.isUndefined)(calendarIds)) {
            return '';
        }
        const params = calendarIds.join('&');
        return `booking_calendars=${params}`;
    }
    static encodelocation(location) {
        if ((0, lodash_1.isUndefined)(location) || (0, lodash_1.isEmpty)(location)) {
            return '';
        }
        // locationsは長いので省略する
        return `loc=${location}`;
    }
    static encodeBooker(booker) {
        if ((0, lodash_1.isUndefined)(booker)) {
            return '';
        }
        // locationsは長いので省略する
        return `booker=${booker}`;
    }
    static encodeProxy(proxy) {
        if ((0, lodash_1.isUndefined)(proxy)) {
            return '';
        }
        // locationsは長いので省略する
        return `proxy=${proxy}`;
    }
    static encodeRoom(room) {
        if ((0, lodash_1.isUndefined)(room) || (0, lodash_1.isEmpty)(room)) {
            return '';
        }
        return `room=${room.join('|')}`;
    }
    static encodeBookingId(bookingId) {
        if ((0, lodash_1.isUndefined)(bookingId)) {
            return '';
        }
        // locationsは長いので省略する
        return `booking_id=${bookingId}`;
    }
    static encodeAllowReschedule(allowReschedule) {
        if ((0, lodash_1.isUndefined)(allowReschedule)) {
            return '';
        }
        return `allow_reschedule=1`;
    }
    static encodeAllowCancel(allowCancel) {
        if ((0, lodash_1.isUndefined)(allowCancel)) {
            return '';
        }
        return `allow_cancel=1`;
    }
    static joinParams(...params) {
        const notEmptyParams = params.filter((p) => !(0, lodash_1.isEmpty)(p));
        if (notEmptyParams.length === 0) {
            return '';
        }
        return `+${notEmptyParams.join('+')}`;
    }
}
exports.BookingURLEncoder = BookingURLEncoder;
//# sourceMappingURL=bookingURLEncoder.js.map